import { useTranslation } from 'react-i18next';

import { Modal, ModalAccessor } from '@steelbuy/modal-dialog';
import { ButtonDanger, ButtonSecondary, ModalContent, ModalContentActionBar } from '@steelbuy/ui-primitive';

export type DeleteBulkListingsModalProps = {
    modalAccessor: ModalAccessor;
    onConfirm: () => void;
};

export const DeleteBulkListingsModal = ({ modalAccessor, onConfirm }: DeleteBulkListingsModalProps) => {
    const { t } = useTranslation(['translation', 'uiDomain']);

    const handleConfirm = () => {
        onConfirm();
        modalAccessor.hide();
    };

    return (
        <Modal modalAccessor={modalAccessor}>
            <div className="delete-bulk__content">
                <ModalContent
                    onCloseModal={modalAccessor.hide}
                    headline={t('uiDomain:deleteBulkListingsModal.textContent')}
                >
                    <ModalContentActionBar>
                        <ButtonSecondary label={t('uiDomain:common.cancel')} onClick={modalAccessor.hide} />
                        <ButtonDanger
                            label={t('uiDomain:deleteBulkListingsModal.confirmButtonLabel')}
                            onClick={handleConfirm}
                        />
                    </ModalContentActionBar>
                </ModalContent>
            </div>
        </Modal>
    );
};
